import React, { useState } from "react";
import PropTypes from "prop-types";
import { Typography, makeStyles } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import Add_Payment_Details from "./Add_Payment_Details/AddPaymentDetails";
import A_Button from "../../../../Atoms/Inputs/Buttons/A_Button";
import A_SimpleDialog from "../../../../Atoms/Feedback/Dialogs/A_SimpleDialog";
import CustomFormIds from "../../customForms/customFormIds.js";
import { message } from "../../../../../../Utils/config/messages.js";

const useStyles = makeStyles((theme) => ({
  dialogTitleRoot: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingRight: theme.spacing(1),
  },
  ButtonWrapper: {
    display: "flex",
    flexDirection: "column",
    width: "22px",
    marginRight: "15em",
  },
  button: {
    marginRight: theme.spacing(1),
    marginTop: "6px",
    minWidth: "185px",
  },
  AlertMobile: {
    marginBottom: "30px",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      marginBottom: "30px",
      flexDirection: "column",
      alignItems: "center",
      textAlignLast: "center",
    },
  },
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(4),
  },
  successDialog: {
    "& .MuiDialog-paper": {
      minWidth: 420,
      maxWidth: 440,
      borderRadius: theme.spacing(1.5),
    },
  },
  successContent: {
    position: "relative",
    padding: theme.spacing(4, 4, 3),
  },
  successCloseButton: {
    position: "absolute",
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  successBadge: {
    width: 52,
    height: 52,
    borderRadius: "50%",
    backgroundColor: "#e8f5e9",
    color: "#2e7d32",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.5rem",
  },
  successTitle: {
    marginTop: theme.spacing(2),
    textAlign: "center",
    fontWeight: 600,
  },
  successMessage: {
    marginTop: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

const AddCustomCards = (props) => {
  const { open, onClose, title, afterClose, formtypeId, isEditMode, recordId } =
    props;
  const classes = useStyles();
  const [showCloseWarning, setShowCloseWarning] = useState(false);

  const handleCloseClick = () => {
    setShowCloseWarning(true);
  };

  const cancelClose = () => {
    setShowCloseWarning(false);
  };

  const handleConfirmClose = () => {
    onClose();
  };
  const renderFormByType = () => {
    if (formtypeId === CustomFormIds.ADD_PAYMENT_DETAILS) {
      return (
        <Add_Payment_Details
          open={open}
          onClose={handleCloseClick}
          afterClose={afterClose}
          isEditMode={isEditMode}
          recordId={recordId}
        />
      );
    }
    return <Typography>{message.CUSTOM_FORM_CONFIGURE_ERROR}</Typography>;
  };

  return (
    <>
      <A_SimpleDialog
        title={title || "Payment Details"}
        open={open}
        onClose={handleCloseClick}
        fullWidth
        maxWidth="sm"
        height="500px"
        PaperProps={{
          style: {
            borderRadius: 12,
          },
        }}
        dialogContent={
          <>
            {showCloseWarning && (
              <Alert
                severity="warning"
                className={classes.AlertMobile}
                action={
                  <div className={classes.ButtonWrapper}>
                    <A_Button
                      label="Don't close form"
                      onClick={cancelClose}
                      className={classes.button}
                      color="primary"
                      variant="outlined"
                    />
                    <A_Button
                      label="Close form anyway"
                      color="inherit"
                      onClick={handleConfirmClose}
                      className={classes.button}
                      variant="outlined"
                    />
                  </div>
                }
              >
                <AlertTitle>Warning</AlertTitle>
                <strong>{message.LOSE_PROGRESS}</strong>
              </Alert>
            )}
            {renderFormByType()}
          </>
        }
      />
    </>
  );
};

AddCustomCards.displayName = "AddCustomCards";

AddCustomCards.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  afterClose: PropTypes.func,
  formtypeId: PropTypes.string,
  isEditMode: PropTypes.bool,
  recordId: PropTypes.string,
};

export default AddCustomCards;
